<template>

    <ChartItem ref="chart"></ChartItem>

</template>

<script>
import ChartItem from "@/components/chart-item";


export default {
	name: "student-top-statistics",
	components: {ChartItem},
	data() {
		const width = document.body.clientWidth
		let is_w = width / 1920;is_w=is_w>1?1:is_w
		return {
			el: null,
			show: true,
			orders: [],
			activeIndex: 0,
			config: {
				grid: {
					top: '6%',
					left:12/is_w+'%',
					right:'16%',
					bottom: '12%',
				},
				xAxis: {
					data: 'value',
					axisLabel: {
						formatter: '{value}',
						style: {


							textBaseline: 'top',
							fill: '#cdcac3',
						}
					},
					min: 0,
					max: 790,
					interval: 200,
					axisLine: {
						style: {
							stroke: '#cdcac3',
							lineWidth: 1,
							fontSize: 16
						}
					},
					nameTextStyle: {
						fill: '#fff',
						fontSize: 16
					},
					axisTick: {
						style: {
							stroke: '#cdcac3',
							lineWidth: 1
						}
					}
				},
				yAxis: [

					{

						data: ['张三', '李四', '王五', '赵六', '郑七'],
						axisLine: {
							style: {
								stroke: 'rgba(0,0,0,0)',
								lineWidth: 1
							}
						},
						splitLine: {
							show: false
						},
						axisLabel: {
							formatter: '{value}',
							style: {
								fill: '#cdcac3',
								fontSize: 16
							}
						},
						nameTextStyle: {
							fill: '#fff',
							fontSize: 16
						},
						axisTick: {
							show: false
						}
					},

				],
				series: [

					{
						name: '订单数',

						data: [
							775, 525, 490, 730, 345, 365, 688

						],
						label: {
							show: true,
							position: 'top',
							offset: [22, 0],
							formatter: '¥{value}',
							style: {
								fill: '#cdcac3',
								fontSize: 16
							}
						},

						type: 'bar',
						barWidth: '50%',
						gradient: {
							//color: ['#e4ac3e', '#3b3734'],
							color: ['#e4ac3e', 'rgba(247,191,80,0.4)'],
						},
						animationCurve: 'easeOutBack'
					},

				]
			}
		}
	},

	methods: {
		handleScroll() {
			this.activeIndex++
			if (this.activeIndex > this.orders.length - 1) {
				this.show = false
				this.activeIndex = 0
				setTimeout(() => {
					this.show = true
				}, 600)
			}
		},
		setConfig(option = {}) {
			let config = {...this.config, ...option}

			if (this.el) {
				this.el.setConfig(config)
			} else {
				this.el = this.$refs.chart
				this.el.setConfig(config)
			}
		},
		setOrders(orders) {
			this.show = false
			this.activeIndex = 0
			setTimeout(() => {
				this.show = true
			}, 600)
			this.orders = orders
			this.orders.push(orders[0])
		}

	},
	mounted() {
		setInterval(() => {
			this.handleScroll()
		}, 2000)
	}
}
</script>

<style scoped lang="less">
.student-top {
  width: 96%;
  height: 1.1rem;
  margin: 0 auto;
  top: 10px;
  overflow: hidden;
  background-image: url("../assets/images/student-bg.png");
  background-size: 100% 100%;
  position: relative;

  .scroll-wrap {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;

  }

  .show {
    transition: top 0.5s ease-in;
  }

  .student-top-content {
    width: 100%;
    height: 1.1rem;
    display: flex;
    color: white;
    align-items: center;
    padding-left: 1.1rem;
    font-size: .36rem;
    transition: all 1s ease-in;
  }
}

.student-content {
  position: relative;
  width: 100%;
  height: calc(100% - 1.26rem);
}

</style>
